

































import Vue from 'vue'
import ConfirmDialog from '@/components/elements/ConfirmDialog.vue'
import Utils from '@/helpers/Utils'
import { ButtonElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ButtonEl',

  data: () => ({
    showPopup: false
  }),

  components: { ConfirmDialog },

  methods: {
    getInputRefs (): URLSearchParams | null {
      if (!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'inputReferences')) {
        return null
      }
      const refs = this.templateItemData.inputReferences
      return Utils.getPostParamsByRefs(refs)
    }
  },

  computed: {
    hasPopup (): boolean {
      return !!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'confirmDialog')
    },
    buttonView (): string {
      const hasUri = Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'uri')
      if (hasUri && this.$props.templateItemData.uri.indexOf('logout') !== -1) {
        return 'logout'
      }
      return this.$props.templateItemData.view || 'main'
    }
  },

  props: {
    templateItemData: {
      type: Object as () => ButtonElInterface,
      required: true
    },
    buttonSize: {
      type: String,
      required: false,
      default: 'v-size--x-large'
    }
  }
})
